import { createLocaleTextHook } from '@moonpig/web-core-locale-text'

const dictionary = {
  'card_scene_preview.standard_size': {
    'nl-NL': 'Standaard',
    'en-GB': 'Standard',
  },
  'card_scene_preview.postcard': {
    'en-GB': 'Postcard',
    'nl-NL': 'Briefkaart',
  },
  'card_scene_preview.standard_size_ecard': {
    'nl-NL': 'e-kaart',
    'en-GB': 'eCard',
  },
  'card_scene_preview.image_alt_text': {
    'en-GB': 'background',
    'nl-NL': 'achtergrond',
  },
  'card_scene_preview.add_to_favourites': {
    'en-GB': 'Add this card to your favourites',
    'nl-NL': 'Voeg deze kaart toe aan je favorieten',
  },
  'card_scene_preview.remove_from_favourites': {
    'en-GB': 'Remove this card from your favourites',
    'nl-NL': 'Verwijder deze kaart uit je favorieten',
  },
  'heading.price': {
    'nl-NL': 'Prijs:',
    'en-GB': 'Price:',
  },
  simplified_dispatch_ecard: {
    'nl-NL': 'Direct geleverd in de inbox van je geliefde',
    'en-GB': "Delivered straight to your loved one's inbox",
  },
  'quantity_selector.decrease_quantity': {
    'nl-NL': 'Hoeveelheid verlagen',
    'en-GB': 'Decrease quantity',
  },
  'quantity_selector.increase_quantity': {
    'nl-NL': 'Verhoog de hoeveelheid',
    'en-GB': 'Increase quantity',
  },
  'quantity_selector.quantity': {
    'nl-NL': 'Aantal',
    'en-GB': 'Quantity',
  },
}

export const useLocaleText = createLocaleTextHook({
  dictionary,
})
